import React from 'react'

import GroupMetricForm from 'pages/shared/GroupMetricForm'

import { SinglePanePage } from 'styles/shared'
import { defaultGroupMetric } from 'models/GroupMetric'

const AddGroupMetric = () => {
  return (
    <SinglePanePage>
      <GroupMetricForm
        saveMethod={'create'}
        title="New Group Metric"
        groupMetric={defaultGroupMetric}
      />
    </SinglePanePage>
  )
}

export default AddGroupMetric
